import React from 'react';
import { Link } from 'react-router-dom';
import { getPublicAssetPath } from '../config';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl w-full text-center">
        {/* Logo */}
        <div className="flex items-center justify-center mb-8">
          <img src={getPublicAssetPath('/le_long.png')} alt="Legitimu Logo" className="h-12" />
        </div>

        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="relative inline-block">
            <div className="text-9xl font-bold text-violet-100">404</div>
            <div className="absolute inset-0 flex items-center justify-center">
              <i className="fa-solid fa-file-circle-question text-6xl text-violet-400"></i>
            </div>
          </div>
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Halaman Tidak Ditemukan</h1>
          <p className="text-lg text-gray-600 mb-2">
            Maaf, halaman yang Anda cari tidak dapat ditemukan.
          </p>
          <p className="text-sm text-gray-500">
            Halaman mungkin telah dipindahkan, dihapus, atau URL yang Anda masukkan salah.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Link
            to="/dashboard"
            className="inline-flex items-center px-6 py-3 bg-violet-600 text-white text-sm font-medium rounded-lg hover:bg-violet-700 transition-colors"
          >
            <i className="fa-solid fa-home mr-2"></i>
            Kembali ke Dashboard
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center px-6 py-3 border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors"
          >
            <i className="fa-solid fa-arrow-left mr-2"></i>
            Kembali Sebelumnya
          </button>
        </div>

        {/* Helpful Links */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
          <h3 className="text-sm font-semibold text-gray-900 mb-4">Mungkin Anda Mencari:</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Link
              to="/dashboard"
              className="flex flex-col items-center p-3 text-gray-600 hover:text-violet-600 hover:bg-violet-50 rounded-lg transition-colors"
            >
              <i className="fa-solid fa-chart-line text-2xl mb-2"></i>
              <span className="text-xs font-medium">Dashboard</span>
            </Link>
            <Link
              to="/board"
              className="flex flex-col items-center p-3 text-gray-600 hover:text-violet-600 hover:bg-violet-50 rounded-lg transition-colors"
            >
              <i className="fa-solid fa-file-contract text-2xl mb-2"></i>
              <span className="text-xs font-medium">Agreements</span>
            </Link>
            <Link
              to="/templates"
              className="flex flex-col items-center p-3 text-gray-600 hover:text-violet-600 hover:bg-violet-50 rounded-lg transition-colors"
            >
              <i className="fa-solid fa-layer-group text-2xl mb-2"></i>
              <span className="text-xs font-medium">Templates</span>
            </Link>
            <Link
              to="/support"
              className="flex flex-col items-center p-3 text-gray-600 hover:text-violet-600 hover:bg-violet-50 rounded-lg transition-colors"
            >
              <i className="fa-solid fa-life-ring text-2xl mb-2"></i>
              <span className="text-xs font-medium">Support</span>
            </Link>
          </div>
        </div>

        {/* Additional Help */}
        <div className="mt-8">
          <p className="text-sm text-gray-500">
            Butuh bantuan?{' '}
            <Link to="/support" className="text-violet-600 hover:text-violet-700 font-medium">
              Hubungi Support
            </Link>
            {' '}atau{' '}
            <Link to="/documentation" className="text-violet-600 hover:text-violet-700 font-medium">
              Lihat Dokumentasi
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;

